import { z } from 'zod';
import { TypedApiClient } from '../index';
import { schemas } from '../../generated/api-client';
import { apiPath } from '../path';

// ====== Import schemas from generated ======
const {
  DiscountOptionFirestoreResponse,
  CreateDiscountOptionDto,
  UpdateDiscountOptionDto,
  DeleteDiscountOptionResponseDto,
} = schemas;

// ====== Re-export schemas for external use ======
export const DiscountOptionResponseSchema = DiscountOptionFirestoreResponse;
export const CreateDiscountOptionSchema = CreateDiscountOptionDto;
export const UpdateDiscountOptionSchema = UpdateDiscountOptionDto;

// ====== Type Exports ======
export type DiscountOptionResponse = z.infer<typeof DiscountOptionFirestoreResponse>;
export type CreateDiscountOption = z.infer<typeof CreateDiscountOptionDto>;
export type UpdateDiscountOption = z.infer<typeof UpdateDiscountOptionDto>;

// API factory function
export function createDiscountOptionsApi(client: TypedApiClient) {
  return {
    getDiscountOptions: (): Promise<DiscountOptionResponse[]> => {
      return client.get('/discount-options', {
        responseSchema: z.array(DiscountOptionFirestoreResponse),
      });
    },

    createDiscountOption: (data: CreateDiscountOption): Promise<DiscountOptionResponse> => {
      return client.post('/discount-options', {
        data,
        requestSchema: CreateDiscountOptionDto,
        responseSchema: DiscountOptionFirestoreResponse,
      });
    },

    updateDiscountOption: (id: string, data: UpdateDiscountOption): Promise<DiscountOptionResponse> => {
      return client.patch(apiPath`/discount-options/${id}`, {
        data,
        requestSchema: UpdateDiscountOptionDto,
        responseSchema: DiscountOptionFirestoreResponse,
      });
    },

    deleteDiscountOption: (id: string): Promise<z.infer<typeof DeleteDiscountOptionResponseDto>> => {
      return client.delete(apiPath`/discount-options/${id}`, {
        responseSchema: DeleteDiscountOptionResponseDto,
      });
    },
  };
}
